import { Controller } from "@hotwired/stimulus"

// Drives the role radio-cards in the Invite Team Member modal:
// - highlights the selected card
// - shows the event-manager event picker only for the event_manager role
// - swaps the static "Permissions for <role>" panel to match the selection
export default class extends Controller {
  static targets = ["roleCard", "roleRadio", "eventManagerSection", "permissionsPanel"]
  static values = { eventManagerRole: { type: String, default: "event_manager" } }

  connect() {
    this.refresh()
  }

  // Called on radio change
  selectRole() {
    this.refresh()
  }

  refresh() {
    const role = this.selectedRole
    this.syncCards(role)
    this.syncPermissions(role)
    this.syncEventManagerSection(role)
  }

  get selectedRole() {
    const checked = this.roleRadioTargets.find((radio) => radio.checked && !radio.disabled)
    return checked ? checked.value : null
  }

  syncCards(role) {
    this.roleCardTargets.forEach((card) => {
      card.classList.toggle("is-selected", card.dataset.role === role)
    })
  }

  syncPermissions(role) {
    this.permissionsPanelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.role !== role
    })
  }

  syncEventManagerSection(role) {
    if (!this.hasEventManagerSectionTarget) return
    this.eventManagerSectionTarget.classList.toggle("d-none", role !== this.eventManagerRoleValue)
  }
}
